import React from 'react';
import { connect } from 'react-redux';
import BaseRequestsPaginationPage from '../../../../components/admin/containers/BaseRequestsPaginationPage';
import GeneralTableRow from '../../../../components/hr/components/row';
import Loading from '../../../../components/common/loading/index';
import AllActionButtons from '../../../../components/actions/all';
import requestPageContainer from '../../../../containers/hr/request-page';
import cookieAndLocalStorage from "../../../../helpers/cookieAndLocalStorage";

class RequestsPage extends React.Component {
  constructor(props) {
    super(props);

    this.changeFilter = this.changeFilter.bind(this);
    this.transferSelected = this.transferSelected.bind(this);
    this.transferAll = this.transferAll.bind(this);
    this.state = {
      requests: [],
      requestStatus: 'all'
    };
  }

  async componentDidMount() {
    const { clearState,isActive,isCheckToken } = this.props;
    clearState();

    if ( isActive === true ){
      await isCheckToken();
    }
    if(isActive === false){
      cookieAndLocalStorage()
    }
  }
  async componentWillMount(){
    const { isCheckToken,isActive } = this.props;
    if ( isActive === true ){
      await isCheckToken();
    }
    if(isActive === false){
      cookieAndLocalStorage()
    }
  }


  async transferSelected(selectedRequests) {
    await this.props.puantajTransfer(selectedRequests);
  }
  async transferAll(month, year) {
    await this.props.allPuantajTransfer(month,year);
  }

  changeFilter(filter) {
    const {
      month, year, page, requestStatus
    } = filter;

    this.setState({ requestStatus });

    this.props.fetchRequests(
      {
        month, year, activePage: page, requestStatus, rowCount: 10,
      });
  }

  render() {
    const {
      requestStore, pageCount, match, selectRequest
    } = this.props;

    return (
      <BaseRequestsPaginationPage
        filterOptionValue="hr"
        pageCount={pageCount}
        requestType="hr/requests"
        changeFilter={this.changeFilter}
        showStatus={false}
        defaultMonth={0}
        defaultRequest={false}
        filterMonth
        isHr
      >
        <div className="col-md-12">
          <div
            className="card"
            style={{ background: 'transparent', boxShadow: 'none' }}
          >
            <div className="content table-responsive table-full-width">
              <Loading loading={requestStore.loading} rows={5} colSpan={9}>
                <div>
                  {
                      requestStore.length > 0
                        ? requestStore.map((request) => {
                          const amounts = {
                            month: request.month,
                            year: request.year,
                            rate: request.rate,
                            yi: request.yi,
                            yd: request.yd,
                            ybk: request.ybk,
                            ydbk: request.ydbk,
                          };

                          return (
                            <GeneralTableRow
                              uploaded={request.uploaded}
                              employmentId={request.employmentId}
                              key={request.employmentId
                                      + request.uploaded}
                              amounts={amounts}
                              employee={request.employee}
                              requests={request.harcirahList}
                            />
                          );
                        })
                        : null
                  }
                </div>
              </Loading>
            </div>
          </div>
          <AllActionButtons
            transferSelected={this.transferSelected}
            transferAll = {this.transferAll}
            requestStore={requestStore}
            selectRequest={selectRequest}
            pageCount={match.params.page}
            requestStatus={this.state.requestStatus}
            isHr
          />
        </div>
      </BaseRequestsPaginationPage>
    );
  }
}


export default connect(...requestPageContainer)(RequestsPage);



// WEBPACK FOOTER //
// ./src/pages/travel-expense/detail/hr/index.js